import * as React from "react";

import { UitkCardAloha, UitkCardAlohaView } from "uitk-react-cards";
import {
  UitkFigureAspectRatioType as ExperimentalAspectRatioType,
  UitkImage as ExperimentalImage,
  UitkFigure as ExperimentalFigure,
} from "uitk-react-experimental-images";
import { UitkLayoutGrid, UitkLayoutGridItem, UitkLayoutConditionalGridColumnRow } from "uitk-react-layout-grid";
import { UitkLayoutFlex, UitkLayoutFlexItem } from "uitk-react-layout-flex";
import { UitkExperimentalScrim, UitkScrimType as UitkExperimentalScrimType } from "uitk-react-experimental-scrim";
import { UitkSpacing, UitkSpacingProps } from "uitk-react-spacing";

export type ScrimCardProps = {
  id: string;
  dataTestId?: string;
  className: string;
  titleSlot?: JSX.Element | JSX.Element[];
  aspectRatio: ExperimentalAspectRatioType;
  backgroundImageURL: string;
  subtitleSlot?: JSX.Element | JSX.Element[];
  footerSlot?: JSX.Element | JSX.Element[];
  scrimType?: UitkExperimentalScrimType;
  marginClass?: string;
  spacing?: UitkSpacingProps;
};

export const ScrimCard: React.FC<ScrimCardProps> = ({
  id,
  dataTestId = "scrim-card",
  className,
  titleSlot,
  aspectRatio,
  backgroundImageURL,
  subtitleSlot = null,
  footerSlot = null,
  scrimType = UitkExperimentalScrimType.OVERLAY,
  spacing = {},
}) => {
  const mainGridColumns: UitkLayoutConditionalGridColumnRow = { small: 1, medium: 2 };
  const subheadingCols: UitkLayoutConditionalGridColumnRow = { small: 1, medium: 1 };

  return (
    <section data-testid={dataTestId} id={id}>
      <UitkSpacing {...spacing}>
        <UitkCardAloha className={className} border={true}>
          <UitkCardAlohaView>
            <ExperimentalFigure ratio={aspectRatio}>
              <ExperimentalImage alt="" src={backgroundImageURL} />

              <UitkExperimentalScrim type={scrimType}>
                <UitkSpacing padding={{ inline: "three" }}>
                  <UitkLayoutFlex direction="column" justifyContent="space-between" style={{ height: "inherit" }}>
                    <UitkLayoutFlexItem>
                      <div>
                        {titleSlot && titleSlot}
                        {subtitleSlot && (
                          <UitkSpacing padding={{ blockstart: "three" }}>
                            <UitkLayoutGrid columns={mainGridColumns}>
                              <UitkLayoutGridItem colSpan={subheadingCols}>{subtitleSlot}</UitkLayoutGridItem>
                            </UitkLayoutGrid>
                          </UitkSpacing>
                        )}
                      </div>
                    </UitkLayoutFlexItem>

                    {footerSlot && (
                      <UitkLayoutFlexItem>
                        <div>{footerSlot}</div>
                      </UitkLayoutFlexItem>
                    )}
                  </UitkLayoutFlex>
                </UitkSpacing>
              </UitkExperimentalScrim>
            </ExperimentalFigure>
          </UitkCardAlohaView>
        </UitkCardAloha>
      </UitkSpacing>
    </section>
  );
};
